module.exports = __webpack_public_path__ + "static/media/planet-earth.4f6e859b.svg";